<template>
  <div v-if="aberto" class="aviso" @click.self="emit('cancelar')" @keydown.esc="emit('cancelar')">
    <div class="aviso__caixa" role="dialog" aria-modal="true" aria-labelledby="titulo-do-aviso">
      <h2 id="titulo-do-aviso" class="aviso__titulo">Conteúdo adulto</h2>
      <p class="aviso__texto">
        Este segmento reúne lojas com conteúdo destinado a maiores de idade.
        Para continuar, confirme que você tem <strong>18 anos ou mais</strong>.
      </p>
      <div class="aviso__acoes">
        <button type="button" class="aviso__botao" @click="emit('cancelar')">
          Voltar
        </button>
        <button ref="botaoDeConfirmar" type="button" class="aviso__botao aviso__botao--principal" @click="emit('confirmar')">
          Tenho 18 anos ou mais
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { nextTick, ref, watch } from 'vue';

  const props = defineProps({
    aberto: {
      type: Boolean,
      default: false
    }
  });

  const emit = defineEmits(['confirmar', 'cancelar']);

  const botaoDeConfirmar = ref(null);

  /* Leva o foco para dentro do aviso, para o Esc e o teclado funcionarem. */
  watch(() => props.aberto, (estaAberto) => {
    if (!estaAberto) return;

    nextTick(() => botaoDeConfirmar.value && botaoDeConfirmar.value.focus());
  });
</script>

<style scoped>
  .aviso {
    position: fixed;
    inset: 0;
    z-index: 100;
    display: grid;
    place-items: center;
    padding: var(--espaco-4);
    background: rgba(36, 26, 46, 0.55);
    animation: surgirFundo 0.2s var(--transicao-padrao) both;
  }

  .aviso__caixa {
    width: 100%;
    max-width: 420px;
    padding: var(--espaco-5);
    border-radius: var(--raio-grande);
    background: var(--cor-superficie);
    box-shadow: var(--sombra-forte);
    animation: surgirCaixa 0.28s var(--transicao-padrao) both;
  }

  .aviso__titulo {
    font-size: 1.14rem;
    font-weight: 700;
    color: var(--cor-tinta);
  }

  .aviso__texto {
    margin: var(--espaco-3) 0 var(--espaco-5);
    font-size: 0.9rem;
    line-height: 1.55;
    color: var(--cor-texto-suave);
  }

  .aviso__texto strong {
    color: var(--cor-tinta);
    font-weight: 600;
  }

  .aviso__acoes {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: var(--espaco-2);
  }

  .aviso__botao {
    padding: var(--espaco-3) var(--espaco-4);
    border-radius: var(--raio-pilula);
    background: var(--cor-areia);
    color: var(--cor-texto-suave);
    font-size: 0.85rem;
    font-weight: 700;
    transition: background var(--transicao-padrao), color var(--transicao-padrao);
  }

  .aviso__botao:hover {
    background: var(--cor-marca-clara);
    color: var(--cor-marca-escura);
  }

  .aviso__botao--principal {
    background: var(--cor-marca);
    color: #fff;
  }

  .aviso__botao--principal:hover {
    background: var(--cor-marca-escura);
    color: #fff;
  }

  @keyframes surgirFundo {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  @keyframes surgirCaixa {
    from {
      opacity: 0;
      transform: translateY(12px) scale(0.98);
    }

    to {
      opacity: 1;
      transform: none;
    }
  }
</style>
